<div class="header-label" avanoEllipsis>{{ displayColumn.header | translate }}</div>
<div class="flex-container">
  <ng-content></ng-content>
  <p-sortIcon *ngIf="displayColumn.sortable !== false" [field]="displayColumn.sortField ? displayColumn.sortField : displayColumn.field"> </p-sortIcon>
</div>
